import { Component, Input } from '@angular/core';

import { InlineInputControlComponent } from '../form/inline-input-control/inline-input-control.component';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { FormControl } from '@angular/forms';
import { NotAvailableOverlayComponent } from '../not-available-overlay/not-available-overlay.component';
import { DataService } from '../../../core/providers/data/data.service';
import { ApplyCouponCodeResult, Mutation, MutationApplyCouponCodeArgs } from '../../../graphql/generated/generated-types';
import { APPLY_COUPON_CODE } from './coupon-code.graphql';
import { map, take } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { ToastSeverity } from '../../notification/notification.component';

@Component({
  selector: 'app-coupon-code-input',
  standalone: true,
  imports: [InlineInputControlComponent, ButtonModule, RippleModule, NotAvailableOverlayComponent],
  templateUrl: './coupon-code-input.component.html',
  styleUrl: './coupon-code-input.component.scss'
})
export class CouponCodeInputComponent {
  @Input() showPaymentMethods: boolean = false;
  public gotCoupon: boolean = false;
  public couponCodeControl: FormControl = new FormControl('');

  constructor(private dataService: DataService, private messageService: MessageService){

  }


  public applyCouponCode(){
    this.dataService.mutate<Mutation, MutationApplyCouponCodeArgs>(APPLY_COUPON_CODE, {
      couponCode: this.couponCodeControl?.value || '',
    }).pipe(
      map((data: Mutation) => data.applyCouponCode as ApplyCouponCodeResult),
      take(1),
  ).subscribe({
      next: (response) => {
        switch (response.__typename) {
          case 'Order':
            this.couponCodeControl?.reset();
            this.gotCoupon = false;
            this.messageService.add({ severity: ToastSeverity.Success, key: 'notifications', summary: `Success`, detail: `Discount applied!` });
            break;
          case 'CouponCodeInvalidError':
            this.messageService.add({ severity: ToastSeverity.Error, key: 'notifications', summary: `Error`, detail: `${response.message}` });
          break;
          case 'CouponCodeExpiredError':
            this.messageService.add({ severity: ToastSeverity.Error, key: 'notifications', summary: `Error`, detail: `${response.message}` });
          break;
          case 'CouponCodeLimitError':
            this.messageService.add({ severity: ToastSeverity.Error, key: 'notifications', summary: `Error`, detail: `${response.message}` });
          break;
        }
      },
      error: (error: HttpErrorResponse) => {
        this.couponCodeControl?.reset();
        this.messageService.add({ severity: ToastSeverity.Error, key: 'notifications', summary: 'Error', detail: `${error.message}` });
      }
    })
  }
}
